import React from "react";
import { Link } from "react-router-dom";

const ACTIONS = [
  { key: "dashboard", label: "Dashboard", page: "promotion_dashboard", icon: "bi-speedometer2" },
  { key: "drafting", label: "Promotion Studio", page: "promotion_studio", icon: "bi-pencil-square" },
  { key: "scheduling", label: "Scheduling", page: "promotion_scheduling", icon: "bi-calendar-event" },
];

const PromotionActionNavigation = ({ current = "", promotionUrl }) => (
  <nav className="card shadow-sm border-0 mb-4" aria-label="Promotion actions">
    <div className="card-body">
      <div className="row g-3">
        {ACTIONS.filter((action) => action.key !== current).map((action) => (
          <div className="col-12 col-sm-6 col-lg" key={action.key}>
            <Link
              className="btn btn-outline-primary w-100 h-100 d-flex align-items-center justify-content-center gap-2 py-3"
              to={promotionUrl(action.page)}
            >
              <i className={`bi ${action.icon}`} />
              {action.label}
            </Link>
          </div>
        ))}
      </div>
    </div>
  </nav>
);

export default PromotionActionNavigation;
